import React, { FunctionComponent } from 'react'
import Svg, { G, Mask, Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraFamilyTherapySecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M51.9126 32.0955C51.903 30.7181 51.2978 29.4121 50.2541 28.5123L47.0626 25.7623V18.7167C47.0626 18.2279 46.6654 17.8328 46.1761 17.8328H43.7599C43.2706 17.8328 42.8735 18.2295 42.8735 18.7167V22.1538L34.4031 14.8558C33.0798 13.7149 31.1194 13.7149 29.7961 14.8558L13.9165 28.5393C12.8903 29.4232 12.2882 30.7006 12.2581 32.0542L12.0007 47.1135C11.9658 48.6972 13.243 50 14.8284 50H49.1706C50.7418 50 52.011 48.7226 51.9999 47.1532L51.9126 32.0955Z'
        fill={spotIllustration.secondary.fill}
      />
      <Mask id='mask0_614_2011' maskUnits='userSpaceOnUse' x='12' y='14' width='40' height='36'>
        <Path
          d='M51.9126 32.0953C51.903 30.718 51.2978 29.412 50.2541 28.5122L47.0626 25.7622V18.7165C47.0626 18.2278 46.6654 17.8327 46.1761 17.8327H43.7599C43.2706 17.8327 42.8735 18.2294 42.8735 18.7165V22.1537L34.4031 14.8557C33.0798 13.7148 31.1194 13.7148 29.7961 14.8557L13.9165 28.5392C12.8903 29.4231 12.2882 30.7005 12.2581 32.0541L12.0007 47.1134C11.9658 48.6971 13.243 49.9999 14.8284 49.9999H49.1706C50.7418 49.9999 52.011 48.7225 51.9999 47.1531L51.9126 32.0953Z'
          fill={spotIllustration.primary.fill}
        />
      </Mask>
      <G mask='url(#mask0_614_2011)'>
        <Rect x='32.0059' y='34.368' width='10.0488' height='16.0604' rx='1' fill={spotIllustration.primary.fill} />
      </G>
      <Rect x='17.9375' y='31.3567' width='9.04388' height='9.034' rx='1' fill={spotIllustration.primary.fill} />
    </Svg>
  )
}
